<template>
  <div>
      <div v-if="!numero">
      <body class="font-sans text-gray-700">
        <div class="container mx-auto p-8 flex">
          <div class="max-w-md w-full mx-auto">
            <div class="bg-white rounded-lg  shadow-2xl">
              <div class="p-8">
                <!--<a href=".">-->
                <h1 class="text-4xl text-center mb-12 font-thin">
                  Inicia sesión nuevamente
                </h1>

                <a href=".">
                  <button
                    class="w-full p-3 font-bold text-xl hover:bg-blue-400 mt-1 bg-blue-600 text-white rounded shadow"
                  >
                    Entrar
                  </button>
                </a>
              </div>

              <div
                class="flex justify-between p-8 text-sm border-t border-gray-300 bg-gray-100"
              ></div>
            </div>
          </div>
        </div>
      </body>
    </div>
    <div v-if="numero" >
        <div class="box-content mx-52 mt-10 font-bold">
        <p
          class="text-blue-400 uppercase shadow-xl rounded text-center mt-2 bg-white w-auto p-5"
        >
          maestro de mantenimineto de tipos de documentos
        </p>
      </div>


      <modalTipodedocumentos></modalTipodedocumentos>
      <tablaTipodedocumentos class=" mt-5"></tablaTipodedocumentos>
    </div>
  </div>
</template>

<script>
import { mapMutations,mapState } from "vuex";

import modalTipodedocumentos from "../components/modales/modalTipodedocumentos.vue";
import tablaTipodedocumentos from "../components/Tablas/tablaTipodedocumentos.vue";

export default {
  name: "tipodedocumentos",
  data() {
    return {
      falso: true,
    };
  },
  components: {
    modalTipodedocumentos,
    tablaTipodedocumentos,
  },
  computed:{
      ...mapState(['numero'])
  },
  methods: {
    ...mapMutations(["value1", "value0"]),
  },
};
</script>

<style>
</style>